/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import React from 'react';
import { View, Dimensions } from 'react-native';
import type { LoadingStateProps } from './types';
import SkeletonLoaderView from '@airasia-phoenix/react-native/components/SkeletonLoaderView';
import { StyleSheet } from 'react-native-unistyles';

export const LoadingStateView = ({}: LoadingStateProps) => {
  const screenWidth = Dimensions.get('window').width;
  const marginHorizontal = 15;
  const availableWidth = screenWidth - marginHorizontal * 2;
  const gap = 1;
  const numberOfItems = 3;
  // Calculate item width: subtract gaps (2 gaps for 3 items) and divide by number of items
  const itemWidth =
    (availableWidth - gap * (numberOfItems - 1)) / numberOfItems;

  return (
    <View style={styles.container}>
      {Array.from({ length: 3 }).map((_, sectionIndex) => (
        <View key={sectionIndex}>
          <SkeletonLoaderView style={styles.headerLoader} />
          <View style={[styles.largeContainer, { width: availableWidth }]}>
            <View style={styles.itemContainer}>
              {Array.from({ length: numberOfItems }).map((_, index) => (
                <SkeletonLoaderView
                  key={index}
                  style={[styles.itemLoader, { width: itemWidth }]}
                />
              ))}
            </View>
          </View>
          <View style={[{ marginTop: 16 }]} />
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create(() => ({
  container: {
    width: '100%',
    paddingTop: 16,
  },
  headerLoader: {
    width: 120,
    height: 24,
    marginHorizontal: 16,
    marginBottom: 16,
    borderRadius: 8,
  },
  largeContainer: {
    height: 200,
    marginHorizontal: 15,
    borderRadius: 20,
    overflow: 'hidden',
  },
  itemContainer: {
    flexDirection: 'row',
    gap: 1,
    width: '100%',
    height: '100%',
  },
  itemLoader: {
    height: '100%',
  },
}));
